import { useSelector } from "react-redux";

export default function LegalDisclaimer() {
  const webSiteData = useSelector((state) => state.website) || {};

  return (
    <main className="flex-1 py-12 bg-white text-gray-900 dark:bg-gray-950 dark:text-gray-100 transition-colors">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-lg p-6 sm:p-8">

            <div className="space-y-8">

              {/* Heading */}
              <div className="text-center">
                <h1 className="text-3xl sm:text-4xl font-bold">
                  ★★ Legal Disclaimer ★★
                </h1>
              </div>

              {/* Content Hosting */}
              <section>
                <h3 className="text-xl font-semibold mb-2">
                  Content Hosting:
                </h3>
                <p className="text-sm sm:text-base text-gray-600 dark:text-gray-400 leading-relaxed">
                  footplayhd.com does not host or upload any video content. All streams are embedded from publicly available third-party sources.
                </p>
              </section>

              {/* Copyright */}
              <section>
                <h3 className="text-xl font-semibold mb-2">
                  Copyright Notice:
                </h3>

                <p className="text-sm sm:text-base text-gray-600 dark:text-gray-400 leading-relaxed">
                  We do not claim ownership of any content displayed on this platform. All trademarks, logos, and media belong to their respective owners.
                </p>
              </section>

              {/* Legal Responsibility */}
              <section>
                <h3 className="text-xl font-semibold mb-2">
                  Legal Responsibility:
                </h3>

                <p className="text-sm sm:text-base text-gray-600 dark:text-gray-400 leading-relaxed">

                  footplayhd.com is not responsible for the legality of content hosted by third parties. Users must ensure that content access is legal in their region.
                </p>
              </section>

              {/* DMCA */}
              <section>
                <h3 className="text-xl font-semibold mb-2">
                  DMCA Compliance:
                </h3>

                <p className="text-sm sm:text-base text-gray-600 dark:text-gray-400 leading-relaxed">
                  If you are a copyright owner and believe that content infringes your rights, don't hesitate to contact the hosting provider directly. We will respond to proper DMCA requests.
                </p>
              </section>

              {/* Contact */}
              {webSiteData?.supportEmail &&
                <section>
                  <h3 className="text-xl font-semibold mb-2">
                    Contact Information:
                  </h3>
                  <p className="text-sm sm:text-base text-gray-600 dark:text-gray-400 leading-relaxed">
                    For any inquiries, please email us at {" "}
                    <span className="font-semibold text-blue-600 dark:text-blue-400">
                      {webSiteData?.supportEmail}
                    </span>
                  </p>
                </section>
              }

            </div>

          </div>
        </div>
      </div>
    </main>
  );
}